module.exports = __webpack_public_path__ + "img/ziggbee-avatar.ba22f526.png";